export enum MqValue {
  Desktop = 'desktop',
  Tablet = 'tablet',
  Mobile = 'mobile',
}

export enum MqKey {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}

export enum MqKeyDesktop {
  Xl = 'xl',
}

export interface MqObject {
  key: MqKey
  value: number
}

export interface StateMq {
  value: MqValue
  mqKey: MqKey
  mqKeyLarge: MqKeyDesktop | null
  list: ReadonlyArray<MqObject>
}

export interface MqPayload {
  currentMediaName: MqValue
  currentMediaKey: MqKey
  desktopMediaKey: MqKeyDesktop | null
}
